import styled from 'styled-components';

export default styled.div`
  background: #fff;
  width: 100%;
`;
